import { gql } from '@apollo/client';

export const SAVE_ORG_ROLES = gql`
  mutation saveOrgRoles($user: ID!, $org: ID!, $roles: JSON) {
    saveOrgRoles(user: $user, org: $org, roles: $roles)
  }
`;
